import HTTP from '../common/http-common';

const END_POINT = '/supplier';

const listSupplier = () => HTTP.get(END_POINT);

const isExistSupplierCode = (supplierCode, supplierId) => HTTP.get(END_POINT +  "/exist/" + supplierCode + "/" + supplierId);

const insertSupplier = (data) => HTTP.post(END_POINT, {
    supplierCode: data.supplierCode,
    supplierName: data.supplierName,
    taxId: data.taxId,
    tel: data.tel,
    contact: data.contact,
    address: data.address
});
const updateSupplier = (data) => HTTP.post(END_POINT + "/" + data.supplierId, {
    supplierCode: data.supplierCode,
    supplierName: data.supplierName,
    taxId: data.taxId,
    tel: data.tel,
    contact: data.contact,
    address: data.address
});

const deleteSupplier = (supplierId) => HTTP.delete(END_POINT + "/" + supplierId);

export {
    listSupplier,
    isExistSupplierCode,
    insertSupplier,
    updateSupplier,
    deleteSupplier
}